var map = {
	"./arrow-down-gray.svg": "./src/drc/assets/icons/arrows/arrow-down-gray.svg",
	"./arrow-down-white.svg": "./src/drc/assets/icons/arrows/arrow-down-white.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/drc/assets/icons/arrows sync recursive ^\\.\\/arrow\\-down\\-.*\\.svg$";